import template from './discard-seat-on-traveller-change.html';
import tripEvents from '../../trip/config/events.constant';

const DIRECTIVE_NAME = DiscardSeatOnTravellerChange.DIRECTIVE_NAME = 'ktDiscardSeatOnTravellerChange';
export default function DiscardSeatOnTravellerChange() {
    return {
        restrict: 'A',
        template,
        bindToController: true,
        controller: DiscardSeatOnTravellerChangeController,
        controllerAs: '$ctrl',
        scope: {
            traveller: `=${DIRECTIVE_NAME}`,
            selectedSeats: `=${DIRECTIVE_NAME}SelectedSeats`,
        },
        link: ($scope, $elem, $attrs, $ctrl) => $ctrl.$onInit(),
    };
}

export function DiscardSeatOnTravellerChangeController(
    $scope,
    selectedSeatsService,
    tripTravellerAllocationService,
    discardSeatOnTravellerChangeService,
    tripTravellerAllocationPassengerService
) {
    'ngInject';

    const vm = this;

    Object.assign(vm, {
        $onInit,
    });

    function $onInit() {
        initTravellerWatcher();
    }

    function initTravellerWatcher() {
        $scope.$watch(() => vm.traveller, (newValue, oldValue) => {
            const hasTravellerChanged = discardSeatOnTravellerChangeService.hasTravellerInformationBeenChanged(newValue, oldValue);
            if (!hasTravellerChanged) {
                return;
            }

            const isSeatOrFfnSelectedForTraveller = selectedSeatsService.isSeatOrFfnSelectedForTraveller(vm.traveller, vm.selectedSeats);
            if (!isSeatOrFfnSelectedForTraveller) {
                return;
            }

            vm.isMessageVisible = true;
            vm.selectedSeats = selectedSeatsService.deselectAllForTraveller(
                vm.selectedSeats,
                vm.traveller
            );
            tripTravellerAllocationService.saveSeats(vm.selectedSeats)
                .then(() => {
                    $scope.$emit(tripEvents.TRIP_UPDATE_COSTS);
                    $scope.$emit(tripEvents.TRIP_DETAILS_UPDATE_FOR_SEATS);
                });
            vm.previousTravellerFullName = tripTravellerAllocationPassengerService.getTravellerFullName(oldValue);
        }, true);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/traveller/discard-seat-on-traveller-change/discard-seat-on-traveller-change-component.js